'use es6';

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withSuspensionBanners } from 'ui-suspension-banners-lib';
import PreviewViewportSizeHOC from 'ContentEditorUI/js/containers/PreviewViewportSizeHOC';
import { undoModuleReducerChange as undoModuleReducerChangeAction, redoModuleReducerChange as redoModuleReducerChangeAction } from 'ContentEditorUI/redux/actions/undoRedoActions';
import AppWideKeyboardShortcutsContainer from 'ContentEditorUI/containers/AppWideKeyboardShortcutsContainer';
import BrandMigrationAlert from 'ContentEditorUI/components/messages/BrandMigrationAlert';
import { CONTENT_PANE_CLASSNAME, EDIT_PANE_CLASSNAME } from 'ContentEditorUI/constants/dom';
import { openPanel } from 'ContentEditorUI/redux/actions/panelActions';
import { compose } from 'redux';
import PreloadedIframeProxy from 'ContentEditorUI/components/temp/PreloadedIframeProxytoExtract';
import { clearSelectedItem as clearSelectedItemAction } from 'ContentEditorUI/redux/actions/selectionActions';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import SkeletonPreviewIframeStyler from 'ContentEditorUI/containers/SkeletonPreviewIframeStyler';
import PageIframeMessagingAreaContainer from 'page-editor-ui/containers/PageIframeMessagingAreaContainer';
import PreviewIframeStylesManager from 'ContentEditorUI/utils/PreviewIframeStylesManager';
import { getPreviewIframeWrapperElement } from 'ContentEditorUI/lib/layoutDom';
import NewMlangVariantFromMasterWarning from 'page-editor-ui/components/NewMlangVariantFromMasterWarning';
import ContentPreviewWrapper from 'page-editor-ui/containers/ContentPreviewWrapper';
import { getIsUngatedForUniversalThemeEditor } from 'page-editor-ui/redux/selectors/authSelectors';
import { getActiveSidebarPanel } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  selectedItemId: getSelectedItemId(state),
  isInDefaultBreakpointMode: getIsInDefaultBreakpointMode(state),
  activeSidebarPanel: getActiveSidebarPanel(state),
  isUngatedForUniversalThemeEditor: getIsUngatedForUniversalThemeEditor(state)
});
const mapDispatchToProps = {
  redoModuleReducerChange: redoModuleReducerChangeAction,
  undoModuleReducerChange: undoModuleReducerChangeAction,
  openPanel,
  clearSelectedItem: clearSelectedItemAction
};
class ContentViewContainer extends Component {
  constructor(...args) {
    super(...args);
    this.handleClickOutsideIframe = () => {
      const {
        clearSelectedItem,
        isInDefaultBreakpointMode,
        selectedItemId
      } = this.props;
      if (!isInDefaultBreakpointMode && selectedItemId) {
        clearSelectedItem();
      }
    };
  }
  componentDidMount() {
    this.getPreviewIframeWrapperElement().addEventListener('click', this.handleClickOutsideIframe);
  }
  componentDidUpdate() {
    const {
      isUngatedForUniversalThemeEditor,
      activeSidebarPanel
    } = this.props;
    if (isUngatedForUniversalThemeEditor && activeSidebarPanel === SIDEBAR_PANELS.design) {
      PreviewIframeStylesManager.setHasPreviewIframeWrapper(true);
    }
  }
  componentWillUnmount() {
    this.getPreviewIframeWrapperElement().removeEventListener('click', this.handleClickOutsideIframe);
  }
  getPreviewIframeWrapperElement() {
    if (!this.previewIframeWrapperElement) {
      this.previewIframeWrapperElement = getPreviewIframeWrapperElement();
    }
    return this.previewIframeWrapperElement;
  }

  // TODO make any parent app click (outside edit sidebar?) clear selection?

  renderPreviewContent() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: `ceui-pane ${CONTENT_PANE_CLASSNAME} flex-container`,
        children: /*#__PURE__*/_jsxs("div", {
          className: `${EDIT_PANE_CLASSNAME}`,
          children: [/*#__PURE__*/_jsx(NewMlangVariantFromMasterWarning, {}), /*#__PURE__*/_jsx(PageIframeMessagingAreaContainer, {
            iframeWrapperElement: this.getPreviewIframeWrapperElement()
          }), /*#__PURE__*/_jsx(BrandMigrationAlert, {}), /*#__PURE__*/_jsxs("div", {
            className: "contentEditor-iframe",
            children: [/*#__PURE__*/_jsx("div", {
              className: "contentEditor-moduleHoverMenu"
            }), /*#__PURE__*/_jsx("div", {
              className: "contentEditor-moduleHoverMenu-SmartContent"
            }), /*#__PURE__*/_jsx(PreloadedIframeProxy, {
              proxyTop: true,
              proxyLeft: true,
              proxyRight: true,
              proxyDisplay: true,
              iframeWrapperElement: this.getPreviewIframeWrapperElement(),
              iframeStylesManager: PreviewIframeStylesManager
            }), /*#__PURE__*/_jsx(SkeletonPreviewIframeStyler, {
              iframeWrapperElement: this.getPreviewIframeWrapperElement()
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(AppWideKeyboardShortcutsContainer, {
        redoAction: this.props.redoModuleReducerChange,
        undoAction: this.props.undoModuleReducerChange
      })]
    });
  }
  render() {
    const {
      isUngatedForUniversalThemeEditor,
      activeSidebarPanel
    } = this.props;
    if (isUngatedForUniversalThemeEditor && activeSidebarPanel === SIDEBAR_PANELS.design) {
      return /*#__PURE__*/_jsx(ContentPreviewWrapper, {
        children: this.renderPreviewContent()
      });
    }
    return this.renderPreviewContent();
  }
}
ContentViewContainer.propTypes = {
  redoModuleReducerChange: PropTypes.func.isRequired,
  undoModuleReducerChange: PropTypes.func.isRequired,
  clearSelectedItem: PropTypes.func.isRequired,
  selectedItemId: PropTypes.string,
  isInDefaultBreakpointMode: PropTypes.bool.isRequired
};
const ConnectedContentViewContainer = compose(connect(mapStateToProps, mapDispatchToProps))(withSuspensionBanners('landingpages-trusted')(ContentViewContainer));

// Need to make PreviewViewportSizeHOC a _parent_ of ContentViewContainer, because it needs to know
// when the edit pane has been fully mounted (and that is easier by making it a parent instead of passing
// `hasMounted={true}` to a child component)
export default PreviewViewportSizeHOC(ConnectedContentViewContainer);